import { Button, Typography, Box } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import DrinkOfChoiceStepRadioButtons from "./RadioButtons/DrinkOfChoiceStepRadioButtons";
import { useState } from "react";

const drinkType = [
  { id: "1", label: "Beer", value: "Beer" },
  { id: "2", label: "Cider", value: "Cider" },
  { id: "3", label: "Wine", value: "Wine" },
  { id: "4", label: "Hard Liquor", value: "Hard Liquor" },
  { id: "5", label: "Home Brew", value: "Home Brew" },
];

type FormValues = {
  drinkName: string;
};

const DrinkOfChoiceStep = ({
  updateStep,
  previousStep,
  formData,
  setFormData,
  step,
}: any) => {
  const methods = useForm<FormValues>({
    defaultValues: { drinkName: formData.choiceStep.drinkName },
    mode: "onChange",
  });

  const [clickButton, setClickButton] = useState(false);

  const { handleSubmit } = methods;

  const formSubmit = (data: any) => {
    setFormData({
      ...formData,
      choiceStep: data.target.defaultValue,
    });
    setClickButton(true);
    setTimeout(() => {
      updateStep();
    }, 500);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(formSubmit)}>
          <Box
            sx={{
              height: { xs: "400px", lg: "502px" },

              display: "flex",
              background: "#F2F2F2",
              borderTopRightRadius: { xs: 0, lg: "18px" },
              borderBottomRightRadius: { xs: "18px", lg: "18px" },
              borderBottomLeftRadius: { xs: 18, lg: "0" },
              flexDirection: "column",
              padding: { xs: "0 0 0 0", lg: "0" },
              alignItems: "center",

              justifyContent: "flex-start",
              flexGrow: "1",
            }}
          >
            <Box
              sx={{
                width: "100%",
                padding: {
                  xs: "0 0 4% 0",
                  sm: "0 0 10px 0",
                  lg: "25px 0 0 0 ",
                },
                margin: {
                  xs: "20px 0 0 0",
                  sm: "100px 0 0 0",
                  lg: "0% 0 0 0",
                },
                display: { xs: "none", lg: "flex" },
                justifyContent: { xs: "space-between", lg: "flex-start" },
              }}
            >
              <Button
                onClick={previousStep}
                sx={{
                  height: "2.7rem",
                  borderRadius: "50px",
                  width: { xs: "50%", lg: "7rem" },
                  color: "#FF3A18",

                  ":hover": {
                    backgroundColor: "transparent",
                  },
                }}
                type="submit"
                variant="text"
              >
                <Typography
                  sx={{
                    fontFamily: "Manrope",
                    textTransform: "capitalize",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  Back
                </Typography>
              </Button>
            </Box>

            <Box
              className="transitions"
              sx={{
                position: "relative",
                display: "flex",
                alignSelf: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box>
                <DrinkOfChoiceStepRadioButtons
                  name="drinkName"
                  options={drinkType}
                  step={step}
                  onClickButton={formSubmit}
                />
                <Box
                  sx={{
                    padding: { xs: "25px 0 0% 0", lg: "0 0 4% 0 " },
                    margin: { xs: "-0 0 0 0", lg: "0 0 20px 0" },
                    display: { xs: "flex", lg: "none" },
                    justifyContent: {
                      xs: "space-between",
                      lg: "space-between",
                    },
                    zIndex: "5",
                  }}
                >
                  <Button
                    onClick={previousStep}
                    sx={{
                      height: "2.7rem",
                      borderRadius: "50px",
                      width: { xs: "0%", lg: "7rem" },
                      color: "#FF3A18",

                      ":hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                    type="submit"
                    variant="text"
                  >
                    <Typography
                      sx={{
                        fontFamily: "Manrope",
                        textTransform: "capitalize",
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      Back
                    </Typography>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </>
  );
};

export default DrinkOfChoiceStep;
